import React from "react";
import { FaBlog, FaCalendarAlt } from "react-icons/fa";

const calendlyLinks = {
14:  "https://calendly.com/ritu-datagenit/30min?utm_source=authkey&utm_medium=console&utm_campaign=WhatsApp_onboarding&utm_id=01",
1779: "https://calendly.com/princejha8219/authkey-io-demo-or-discussion?utm_source=authkey&utm_medium=console&utm_campaign=WhatsApp_onboarding&utm_id=01"
};

const WhatsappBusinessAccount = () => {

    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const reseller_id = lStorage.user.reseller_id;

  const handleClick = () => {
    let link;

    if (reseller_id && calendlyLinks[reseller_id]) {
      
      link = calendlyLinks[reseller_id];
    } else {
      const allLinks = Object.values(calendlyLinks);
      link = allLinks[Math.floor(Math.random() * allLinks.length)];
    }

    window.open(link, "_blank");
  };
    return (
        <div
            style={{
                padding: "40px",
                background: "linear-gradient(135deg, #f4f8ff, #e9f0ff)",
                borderRadius: "16px",
                margin: "40px auto",
                maxWidth: "1200px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
                <div>
                    <h2 style={{ fontWeight: "700", color: "#2c257d", marginBottom: "16px", fontSize: "2rem" }}>
                        Apply for WhatsApp Business API
                    </h2>
                    <p style={{ fontSize: "1.1rem", fontWeight: "500", color: "#555" }}>
                        Click below to read our blog or schedule a call to get started.
                    </p>
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <p style={{ color: "#444", margin: "14px 0", fontWeight: "500" }}>
                                Requirements to apply:
                            </p>
                            <ul style={{ paddingLeft: "20px", color: "#555", marginBottom: "20px" }}>
                                <li>Registered Business</li>
                                <li>Working Website</li>
                            </ul>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
                                <button className="btn"
                                    onClick={handleClick}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "12px 22px",
                                        backgroundColor: "#64b5f6",
                                        color: "#0d47a1",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        fontWeight: "600",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = "#42a5f5";
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = "#64b5f6";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
                                    }}
                                >
                                    <FaCalendarAlt />
                                    Schedule Demo
                                </button>

                                <a
                                    href="https://authkey.io/blogs/whatsapp-onboarding-embedded-signup-authkey/?utm_source=console&utm_medium=Whatsapp_button&utm_campaign=help"
                                    target="_blank"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "12px 22px",
                                        backgroundColor: "#9575cd",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        fontWeight: "600",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = "#7e57c2";
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = "#9575cd";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
                                    }}
                                >
                                    <FaBlog />
                                    Read Blog
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-4 mt-lg-0">
                            <iframe
                                style={{
                                    width: "100%",
                                    maxWidth: "420px",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    minHeight: "250px",
                                }}
                                src="https://www.youtube-nocookie.com/embed/JJbZxHL-HLY?rel=0"
                                title="WhatsApp API Onboarding"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatsappBusinessAccount;
